import Bolt from "@mui/icons-material/Bolt";
import { type FC, useCallback } from "react";
import { useLexicalContext } from "../../../lexical-context";
import { useLexicalParentNodeContext } from "../../../lexical-parent-node-context";
import type { ToolbarProps } from "../props";
import { ToolbarIconButton } from "../toolbar-icon-button";

export const DynamicContentButton: FC<ToolbarProps & { label?: string; onClose?: () => void }> = ({
  disabled,
  label,
  onClose,
}) => {
  const {
    editorModal: { handleOpen },
  } = useLexicalContext();

  const { dynamicContent } = useLexicalParentNodeContext();

  const onClick = useCallback(() => {
    handleOpen({ type: "dynamic-content", data: { mode: "add" } });
    onClose?.();
  }, [handleOpen, onClose]);

  return (
    <ToolbarIconButton
      data-analytics-id="lexical-toolbar-dynamic-content"
      sx={{ width: label && "100%", justifyContent: "start" }}
      disabled={disabled || dynamicContent}
      label={label}
      icon={<Bolt fontSize="medium" />}
      data-testid="toolar-button-columns"
      aria-label={label ?? "Dynamic Content"}
      tabIndex={-1}
      onClick={onClick}
    />
  );
};
